import Alpine from "alpinejs"

Alpine.data("popover", (sticky = false) => ({
    open: false,
    init() {
        const { dialog, button } = this.$refs

        dialog.addEventListener("toggle", (event) => {
            dialog.classList.remove("open")
            this.open = event.newState === "open"
            dialog.scrollTop = 0
            dialog.addEventListener("animationend", () => {
                this.open && dialog.classList.add("open")
            })
        })

        const updatePosition = () => {
            console.log(window.getComputedStyle(dialog).getPropertyValue("transform-origin"))
            switch (window.getComputedStyle(dialog).getPropertyValue("transform-origin")) {
                // top right aligned
                case "100% 0%":
                    dialog.style.left = `${this.$refs.button.getBoundingClientRect().left}px`
                    dialog.style.bottom = `${this.$refs.button.getBoundingClientRect().top + 16}px`
                    break
                // bottom left aligned

                // top left aligned/default
                case "0% 0%":
                default:
                    dialog.style.right = `${this.$refs.button.getBoundingClientRect().right}px`
                    dialog.style.bottom = `${this.$refs.button.getBoundingClientRect().top + 16}px`
            }

            if (dialog.classList.contains("c-popover--top-left")) {
                dialog.style.left = `${this.$refs.button.getBoundingClientRect().right}px`
                dialog.style.top = `${this.$refs.button.getBoundingClientRect().top + 16}px`
            }
            if (dialog.classList.contains("c-popover--top-right")) {
                dialog.style.left = `${this.$refs.button.getBoundingClientRect().right}px`
            }
            if (dialog.classList.contains("c-popover--bottom-left")) {
                dialog.style.top = `${this.$refs.button.getBoundingClientRect().bottom + 16}px`
            }
            if (dialog.classList.contains("c-popover--bottom-right")) {
                dialog.style.top = `${this.$refs.button.getBoundingClientRect().bottom + 16}px`
            }
            dialog.style.width = `${this.$el.offsetWidth}px`
        }

        if (sticky) {
            updatePosition()
            window.addEventListener("scroll", updatePosition, { passive: true })
            window.addEventListener("resize", updatePosition, { passive: true })
        }

        if (button) {
            let buttonAbortController = new AbortController()
            button.addEventListener("pointerenter", () => {
                buttonAbortController = new AbortController()
                this.open && button.classList.add("hovered")
                button.addEventListener(
                    "animationiteration",
                    () => {
                        button.classList.add("hovered")
                    },
                    { once: true, signal: buttonAbortController.signal },
                )
            })

            button.addEventListener("pointerleave", () => {
                buttonAbortController?.abort()
                button.classList.remove("hovered")
            })
        }
    },
    toggle() {
        if (this.open) {
            this.$refs.dialog.hidePopover()
        } else {
            this.$refs.dialog.showPopover()
        }
    },
}))
